import TerminalModal from "components/Model/AutomationTerminalModal";
import automationClient from "lib/automation-client";
import moment from "moment";
import React from "react";
import { Button } from "react-bootstrap";


function ProcessLogTable({ automationName }) {
    const [processList, setProcessList] = React.useState([])
    const [showMore, setShowMore] = React.useState(false)

    const fetchProcess = async () => {
        const { process } = await automationClient.getAllAction(automationName)
        if (process) {
            setProcessList(process)
        }
    }


    React.useEffect(() => {
        fetchProcess()
    }, [])

    if (!processList || processList.length < 1) {
        return <tr>
            <td colSpan={7}>
                <div className="d-flex justify-content-center">
                    <img src={"/assets/nodata.jpg"} />
                </div>
            </td>
        </tr>
    }
    return (
        <tr>
            <td colSpan={7} className="m-0 p-0">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">processId</th>
                            <th scope="col">Start Time</th>
                            <th scope="col">End Time</th>
                            <th scope="col">Executing Time</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            processList.slice(0, showMore ? processList.length : 5).map((_state, _index) =>
                                <tr key={_index}>
                                    <th>{_state.automationName}_{_state?.processId}</th>
                                    <td>{_state?.startTime ? moment(_state?.startTime).format('lll') : '-'}</td>
                                    <td>{_state?.endTime ? moment(_state?.endTime).format('lll') : '-'}</td>
                                    <td>{_state?.endTime && moment.duration(moment(_state?.endTime).diff(_state?.startTime)).humanize()}</td>
                                    <td>
                                        <TerminalModal automationName={_state?.automationName} processId={_state?.processId} title={"Log_"}/>
                                    </td>
                                </tr>
                            )
                        }
                        {
                            processList.length > 5 && <tr>
                                <td colSpan={7}>
                                    <div className="d-flex justify-content-center">
                                        <Button onClick={() => setShowMore(_state => !_state)}>Show more</Button>
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table></td>
        </tr>
    );
}

export default ProcessLogTable;
